import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" }
const _hoisted_4 = { class: "-mt-12 sm:-mt-16 sm:flex sm:items-end sm:space-x-5" }
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "mt-6 sm:flex-1 sm:min-w-0 sm:flex sm:items-center sm:justify-end sm:space-x-6 sm:pb-1" }
const _hoisted_8 = { class: "sm:hidden md:block mt-6 min-w-0 flex-1" }
const _hoisted_9 = { class: "text-2xl font-bold text-gray-900 truncate" }
const _hoisted_10 = { class: "mt-2 flex flex-col justify-stretch space-y-3 sm:flex-row sm:space-y-0 sm:space-x-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "宇宙祈願", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "宇宙供養", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "フォロー", -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "フォローを外す", -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "mt-2 flex items-center text-sm text-gray-500" }
const _hoisted_18 = { class: "mt-2 flex items-center text-sm text-gray-500" }
const _hoisted_19 = {
  key: 0,
  class: "mt-2 flex items-center text-sm text-gray-500"
}
const _hoisted_20 = ["href"]
const _hoisted_21 = { class: "mt-10 pb-4" }
const _hoisted_22 = { class: "relative" }
const _hoisted_23 = { class: "relative mx-auto px-2" }
const _hoisted_24 = { class: "rounded-lg bg-white shadow-lg grid grid-cols-3" }
const _hoisted_25 = { class: "flex flex-col border-b border-gray-100 p-1 text-center sm:border-0 sm:border-r" }
const _hoisted_26 = { class: "order-1 font-bold tracking-tight text-color-2" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("dt", { class: "order-2 mt-2 text-xs font-medium text-gray-500" }, "フォロワー", -1)
const _hoisted_28 = { class: "flex flex-col border-t border-b border-gray-100 p-1 text-center sm:border-0 sm:border-l sm:border-r" }
const _hoisted_29 = { class: "order-1 font-bold tracking-tight text-color-2" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("dt", { class: "order-2 mt-2 text-xs font-medium text-gray-500" }, "投稿", -1)
const _hoisted_31 = { class: "flex flex-col border-t border-gray-100 p-1 text-center sm:border-0 sm:border-l" }
const _hoisted_32 = { class: "order-1 font-bold tracking-tight text-color-2" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("dt", { class: "order-2 mt-2 text-xs font-medium text-gray-500" }, "お参り", -1)
const _hoisted_34 = { class: "px-4 mt-4 flex justify-between items-center" }
const _hoisted_35 = { class: "flex items-center" }
const _hoisted_36 = ["src"]
const _hoisted_37 = { class: "ml-2 text-sm text-gray-400" }
const _hoisted_38 = ["src"]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "mt-1 mb-2 flex justify-center text-gray-400 text-sm" }, " スタンプでお参り・供養できます ", -1)
const _hoisted_40 = { class: "mt-4" }
const _hoisted_41 = { class: "border-b border-gray-200" }
const _hoisted_42 = {
  class: "-mb-px flex",
  "aria-label": "Tabs"
}
const _hoisted_43 = {
  key: 0,
  class: "max-w-3xl mx-auto m-4 overflow-hidden"
}
const _hoisted_44 = {
  key: 0,
  class: "flow-root mt-6"
}
const _hoisted_45 = {
  role: "list",
  class: "-my-5 divide-y divide-gray-200"
}
const _hoisted_46 = { class: "text-sm font-semibold text-gray-800" }
const _hoisted_47 = ["innerHTML"]
const _hoisted_48 = { class: "flex justify-end" }
const _hoisted_49 = { class: "text-sm text-gray-400" }
const _hoisted_50 = {
  key: 1,
  class: "my-4 p-6 text-gray-400"
}
const _hoisted_51 = {
  key: 1,
  class: "max-w-3xl mx-auto my-4 overflow-hidden"
}
const _hoisted_52 = {
  key: 0,
  role: "list",
  class: "mt-4 grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2 sm:gap-x-6 lg:grid-cols-3 xl:gap-x-8"
}
const _hoisted_53 = { class: "group block w-full aspect-w-10 aspect-h-7 rounded-lg bg-gray-100 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-offset-gray-100 focus-within:ring-indigo-500 overflow-hidden" }
const _hoisted_54 = ["src"]
const _hoisted_55 = { class: "mt-2 block text-sm font-medium text-gray-900 truncate pointer-events-none" }
const _hoisted_56 = {
  key: 1,
  class: "my-4 p-6 text-gray-400"
}
const _hoisted_57 = ["onClick"]
const _hoisted_58 = {
  key: 0,
  class: "flex min-h-full items-center justify-center p-4 text-center sm:items-center sm:p-0"
}
const _hoisted_59 = ["src"]

import Album from "@/models/Album";
import Customer from "@/models/Customer";
import Information from "@/models/Information";
import Temple from "@/models/Temple";
import { formatSnsTime } from "@/utils/TextUtil";
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

import AppHeader from "@/components/AppHeader.vue";
import Timeline from "@/models/Timeline";
import Praying from "@/models/Praying";


export default /*#__PURE__*/_defineComponent({
  __name: 'TempleDetailView',
  setup(__props) {

const store = useStore();
const route = useRoute();

const temple_id = ref<string>("");
const temple = ref<Temple>({} as Temple);

const following = ref<boolean | null>(null);

const type = ref<string>("information");

const timelines = ref<Timeline[]>([]);
const albums = ref<Album[]>([]);

const prayedType = ref<string | null>(null);

const showing_modal = ref<boolean>(false);
const show_praying_image = ref<boolean>(false);

const formatdate = (datetime: Date | null) => {
  return formatSnsTime(datetime);
};

const refresh = () => {
  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      temple.value = await Temple.get(temple_id.value);
      await Promise.all([getInformationAsync(), getIsFollow()]);
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

const refreshInformation = () => {
  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      await getInformationAsync();
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

const getInformationAsync = async () => {
  const result = await Timeline.searchTemples(
    temple_id.value,
    store.state.customer!.id
  );
  timelines.value = result;
};

const refreshAlbum = () => {
  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      await getAlbumAsync();
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

const refreshPrayedType = () => {
  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      await getPrayedTypeAsync();
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

const getPrayedTypeAsync = async () => {
  const praying = await Praying.get(temple_id.value, store.state.customer!.id);
  if (!praying) {
    prayedType.value = null;
  } else {
    prayedType.value = praying.stamp_type;
  }
};

const getAlbumAsync = async () => {
  const result = await Album.searchTemple(temple_id.value);
  albums.value = result.albums;
};

const getIsFollow = async (): Promise<void> => {
  following.value = await Customer.isFollow(
    store.state.customer!.id,
    temple_id.value
  );
};

const setType = (t: string) => {
  type.value = t;

  if (type.value == "information") {
    refreshInformation();
  } else {
    refreshAlbum();
  }
};


const closeModal = () => {
  show_praying_image.value = false;
  showing_modal.value = false;
};

const togglePraying = () => {
  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      if (prayedType.value) {
        prayedType.value = null;
        temple.value!.praying_stamp1_count = Math.max(0, temple.value!.praying_stamp1_count - 1);
        await Praying.delete(temple.value!.id, store.state.customer!.id);
      } else {
        showing_modal.value = true;
        show_praying_image.value = true;

        prayedType.value = 'type1';
        temple.value!.praying_stamp1_count = temple.value!.praying_stamp1_count + 1;

        const result = await Praying.registerTemple(
          temple.value!.id,
          store.state.customer!.id,
          'type1'
        );

        setTimeout(() => {
          showing_modal.value = false;
          show_praying_image.value = false;
        }, 3000)
      }
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

const follow = () => {
  if (store.state.is_loading) {
    return;
  }
  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      following.value = true;
      if (temple.value) {
        temple.value.follower_count = temple.value.follower_count! + 1;
      }

      const success = await Customer.follow(
        "temple",
        store.state.customer!.id,
        temple_id.value,
        ""
      );
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

const unfollow = () => {
  if (store.state.is_loading) {
    return;
  }
  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      following.value = false;
      if (temple.value) {
        temple.value.follower_count = temple.value!.follower_count - 1;
      }

      const success = await Customer.unfollow(
        store.state.customer!.id,
        temple_id.value
      );

      if (!success) {
        following.value = true;
        if (temple.value) {
          temple.value.follower_count = temple.value.follower_count + 1;
        }
      }
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

onMounted(() => {
  temple_id.value = route.params.temple_id as string;
  refresh();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_fa = _resolveComponent("fa")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(AppHeader),
      _createElementVNode("div", null, [
        _createElementVNode("div", null, [
          _createElementVNode("img", {
            class: "h-32 w-full object-cover lg:h-48",
            src: temple.value.main_image_url ?? require('@/assets/images/empty.png'),
            alt: ""
          }, null, 8, _hoisted_2)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("img", {
                class: "h-24 w-24 rounded-full ring-4 ring-white bg-white sm:h-32 sm:w-32",
                src: 
                  temple.value.selfie_image_url ?? require('@/assets/images/no-selfie-temple.png')
                ,
                alt: ""
              }, null, 8, _hoisted_6)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("h1", _hoisted_9, _toDisplayString(temple.value.name), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                (temple.value.has_wish_menu)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: `/order/wish/${temple.value.id}`,
                      class: "inline-flex justify-center px-4 py-2 bg-color-2 shadow-sm text-sm font-medium rounded-md text-white bg-white"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : _createCommentVNode("", true),
                (temple.value.has_memorial_menu)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 1,
                      to: `/order/pray/${temple.value.id}`,
                      class: "inline-flex justify-center px-4 py-2 bg-color-2 shadow-sm text-sm font-medium rounded-md text-white bg-white"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : _createCommentVNode("", true),
                (following.value != null && following.value == false)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      class: "inline-flex justify-center px-4 py-2 bg-color-2 shadow-sm text-sm font-medium rounded-md text-white bg-white",
                      onClick: follow
                    }, _hoisted_14))
                  : _createCommentVNode("", true),
                (following.value != null && following.value == true)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 3,
                      class: "inline-flex justify-center px-4 py-2 bg-color-2 shadow-sm text-sm font-medium rounded-md text-white bg-white",
                      onClick: unfollow
                    }, _hoisted_16))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_fa, {
              icon: "map-marker-alt",
              class: "mr-2"
            }),
            _createTextVNode(" " + _toDisplayString(temple.value.full_address), 1)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_fa, {
              icon: "phone",
              class: "mr-2"
            }),
            _createTextVNode(" " + _toDisplayString(temple.value.telephone), 1)
          ]),
          (temple.value.website)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createVNode(_component_fa, {
                  icon: "globe",
                  class: "mr-2"
                }),
                _createElementVNode("a", {
                  href: temple.value.website,
                  target: "_blank"
                }, _toDisplayString(temple.value.website), 9, _hoisted_20)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("dl", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("dd", _hoisted_26, _toDisplayString(temple.value.follower_count), 1),
                _hoisted_27
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("dd", _hoisted_29, _toDisplayString(temple.value.post_count), 1),
                _hoisted_30
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("dd", _hoisted_32, _toDisplayString(temple.value.stamp_count), 1),
                _hoisted_33
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("img", {
            class: "h-6 w-6",
            src: require('@/assets/images/ic_stamp1_circle.png')
          }, null, 8, _hoisted_36),
          _createElementVNode("span", _hoisted_37, _toDisplayString(temple.value?.stamp_count), 1),
          _createVNode(_component_fa, {
            icon: "angle-right",
            class: "ml-2 text-xl text-gray-400"
          })
        ]),
        _createElementVNode("button", {
          class: "ml-2 text-sm text-gray-400 flex items-center justify-center",
          onClick: togglePraying
        }, [
          _createElementVNode("img", {
            class: "w-6 h-6 mr-2",
            src: 
              !prayedType.value
                ? require('@/assets/images/ic_stamp1_attention.png')
                : require('@/assets/images/ic_stamp1.png')
            
          }, null, 8, _hoisted_38),
          _createTextVNode(" " + _toDisplayString(prayedType.value ? "スタンプを消す" : "お参り"), 1)
        ])
      ]),
      _hoisted_39,
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("nav", _hoisted_42, [
            _createElementVNode("a", {
              href: "javascript:void(0)",
              class: _normalizeClass(["border-b-2 w-1/2 py-4 px-1 text-center border-b-2 font-medium text-sm", {
                'border-transparent': type.value !== 'information',
                'text-gray-500': type.value !== 'information',
                'border-color-2': type.value == 'information',
                'text-color-2': type.value == 'information',
              }]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (setType('information')))
            }, " お知らせ ", 2),
            _createElementVNode("a", {
              href: "javascript:void(0)",
              class: _normalizeClass(["border-b-2 w-1/2 py-4 px-1 text-center border-b-2 font-medium text-sm", {
                'border-transparent': type.value !== 'album',
                'text-gray-500': type.value !== 'album',
                'border-color-2': type.value == 'album',
                'text-color-2': type.value == 'album',
              }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (setType('album')))
            }, " アルバム ", 2)
          ])
        ])
      ]),
      (type.value == 'information')
        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
            (timelines.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                  _createElementVNode("ul", _hoisted_45, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timelines.value, (timeline) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: "bg-white shadow rounded-lg p-5 mx-4 mb-4",
                        key: timeline.id
                      }, [
                        _createElementVNode("div", null, [
                          _createElementVNode("h3", _hoisted_46, _toDisplayString(timeline.title), 1),
                          _createElementVNode("p", {
                            class: "mt-1 text-sm text-gray-600 line-clamp-2",
                            innerHTML: timeline.body
                          }, null, 8, _hoisted_47),
                          _createElementVNode("div", _hoisted_48, [
                            _createElementVNode("span", _hoisted_49, _toDisplayString(formatdate(timeline.created_at)), 1)
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (!timelines.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_50, " お知らせはありません "))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (type.value == 'album')
        ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
            (albums.value.length)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_52, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(albums.value, (album) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: `${album.target_id}_${album.timestamp}`,
                      class: "relative p-4 bg-white"
                    }, [
                      _createElementVNode("div", _hoisted_53, [
                        (!!album.media_url)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: album.media_url?.original_resource_url,
                              class: "object-cover pointer-events-none group-hover:opacity-75"
                            }, null, 8, _hoisted_54))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("p", _hoisted_55, _toDisplayString(album.comment), 1)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (!albums.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_56, " アルバムはありません "))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (showing_modal.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "fixed inset-0 w-full h-full",
            style: {"background-color":"#999999aa"},
            onClick: _withModifiers(closeModal, ["stop"])
          }, [
            (show_praying_image.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                  _createElementVNode("img", {
                    src: require('@/assets/images/bell1.jpg'),
                    class: "w-2/3"
                  }, null, 8, _hoisted_59)
                ]))
              : _createCommentVNode("", true)
          ], 8, _hoisted_57))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})